const Showcase = () => {
  return (
    <>
      <section className="showcase">
        <div className="showcase-overlay">
          <h1>Showcase SpaceX</h1>
          <p>
            STARSHIP SELECTED BY NASA TO SUPPORT SUSTAINED LUNAR EXPLORATION
          </p>
        </div>
      </section>
    </>
  );
};

export default Showcase;
